import React from "react";
import { IFacility } from "pages/guest/models/facility";
import "./TournamentHeader.scss";
import { useHistory } from "react-router";
import { ITournament } from "redux/reducers/models/tournament";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import { NavigationDropdownNew } from "components/navigationDropdownNew/NavigationDropdownNew";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ITournamentHeaderProps {
  facility: IFacility;
  tournament: ITournament;
}

export default function TournamentHeader(props: ITournamentHeaderProps) {
  const { facility, tournament } = props;
  const history = useHistory();
  const windowSize = useWindowSize();
  const { t } = useTranslation();

  function basePath() {
    return `/tournament/${facility.short_name}/${tournament.handle}`;
  }

  function currentPath() {
    return history.location.pathname.replace(/\/+$/, "");
  }

  function navigateTo(pathEnding: string) {
    history.push(pathEnding ? `${basePath()}/${pathEnding}` : basePath());
  }

  if (facility && tournament) {
    const onHome = currentPath() === `${basePath()}/home`;
    const onRegister = currentPath() === basePath();

    return (
      <div className="tournament-header-container">
        <div className="tournament-header">
          <div className="tournament-header-title-group">
            <img
              className="tournament-header-facility-logo"
              src={tournament.logo_source}
              alt=""
              onClick={() => navigateTo("home")}
            />
            <div>
              <div className="tournament-header-title">{tournament.name ?? ""}</div>
              <div className="tournament-header-sub-title">{facility.long_name ?? ""}</div>
            </div>
          </div>
          {windowSize.width > MOBILE_WIDTH ? (
            <div className="tournament-header-navigation">
              <div
                className={classNames("tournament-header-navigation-item", {
                  "tournament-header-navigation-item-selected": onHome,
                })}
                onClick={() => navigateTo("home")}
              >
                {t("Home")}
              </div>
              <div
                className={classNames("tournament-header-navigation-item", {
                  "tournament-header-navigation-item-selected": onRegister,
                })}
                onClick={() => navigateTo("")}
              >
                {t("Register")}
              </div>
            </div>
          ) : (
            <NavigationDropdownNew
              showPlainTextLabel
              rightAlign
              label={<FontAwesomeIcon icon={["far", "bars"]} size="lg" />}
              sections={[
                [
                  {
                    icon: "house",
                    label: t("Home"),
                    onClick: () => navigateTo("home"),
                  },
                  {
                    icon: "pencil",
                    label: t("Register"),
                    onClick: () => navigateTo(""),
                  },
                ],
              ]}
            />
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }
}
